import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SuspendNonPayState {
    isSuspendNonPay: boolean;
    queryParam: string;
}

const initialState: SuspendNonPayState = {
    isSuspendNonPay: false,
    queryParam: "suspendnonpay"
};

export const suspendNonPaySlice = createSlice({
    name: 'suspendNonPay',
    initialState,
    reducers: {
        setIsSuspendNonPay: (state, action: PayloadAction<boolean>) => {
            state.isSuspendNonPay = action.payload;
        },
    },
});

export const { setIsSuspendNonPay } = suspendNonPaySlice.actions;
export default suspendNonPaySlice.reducer;